// Skin (§11.10): amount and the skin brush (frequency separation keeps the texture).
import { Slider } from '../controls/Slider';
import { BrushControls, ToolButton } from './BrushControls';
import { useActive } from './useActive';
import { useT } from '../../i18n';

export function SkinPanel() {
  const t = useT();
  const { settings, update } = useActive();
  return (
    <div>
      <ToolButton tool="skin" label={t('skinTool')} testId="skin-tool" />
      <div style={{ fontSize: 12, marginBottom: 6, opacity: 0.8 }}>{t('skinHint')}</div>
      <Slider
        label="amount"
        testId="slider-skin-amount"
        value={settings.skin.amount}
        min={0}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.skin.amount = v), f)}
      />
      <BrushControls />
      <button
        disabled={!settings.skin.strokes.length}
        data-testid="skin-clear"
        onClick={() => update((s) => void (s.skin.strokes = []))}
      >
        {t('skinClear')}
      </button>
    </div>
  );
}
